module.exports = __webpack_public_path__ + "img/flow-desc10.550f1356.png";